
import SubscriberContent from "./SubscriberContent";
import Footer from '../../components/Footer';

const SubscribersCalendly: React.FC = () => {
    return (
        <div className="container-fluid mt-2">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        <div className="main-container-inner">
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Virtual Assistants</h1>
                                </div>
                                <SubscriberContent />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscribersCalendly;